import { t } from './i18n';

export const SELECTORS = {
    container: '.appointment-confirmed__container',
    body: '.appointment-confirmed__body',
    card: '.appointment-confirmed__body .card',
    icon: '.appointment-confirmed__body .icon',
    checkIconWrapper: '.icon .custom-check-icon-wrapper',
    informationCard: '.appointment-confirmed__body .information .card',
    staffInfo: '.time-staff__info .staff__info',
    timeInfo: '.time-staff__info .time__info',
    dateInfo: '.date__info',
    actionDiv: '.card .action',
    appointmentButtons: '.appointment-confirm-single',
    title: '.appointment-confirmed__body .title',
    confirmBtn: '#confirm-appointment-btn',
    cancelLink: '#cancel-appointment-link',
    logo: '.appointment__logo',
    pendingBanner: '.pending-approval-banner',
    cancelledBanner: '.cancelled-appointment-banner'
};

export const MESSAGES = {
    errors: {
        get eventIdNotFound() { return t('error_event_id_not_found'); },
        get locationUndefined() { return t('error_location_undefined'); },
        get confirmFailed() { return t('confirm_appointment_failed'); },
        get cancelFailed() { return t('cancel_failed'); },
        get copyFailed() { return t('error_copy_failed'); },
        get eventRoomUrlUnavailable() { return t('error_room_url_unavailable'); },
        get invalidResponse() { return t('error_invalid_response'); },
    },
    success: {
        get addressCopied() { return t('address_copied'); },
        get confirmAppointment() { return t('confirm_appointment_success'); },
        get cancelAppointment() { return t('cancel_success'); }
    },
    confirmations: {
        get cancelAppointment() { return t('confirm_cancel_dialog'); }
    },
    ui: {
        get processing() { return t('processing'); },
        get confirm() { return t('confirmed'); },
        get cancel() { return t('cancel'); },
        get cancelled() { return t('cancelled'); },
        get appointmentCancelled() { return t('appointment_cancelled_title'); },
        get confirmAppointment() { return t('confirm_appointment_btn'); }
    },
    banner: {
        get pendingApproval() { return t('pending_approval_title'); },
        get pendingApprovalDescription() { return t('pending_approval_desc'); },
        get cancelled() { return t('cancelled_banner_title'); },
        get cancelledDescription() { return t('cancelled_banner_desc'); }
    }
};

export const BUTTON_CONFIG = {
    confirm: {
        id: 'confirm-appointment-btn',
        className: 'button--no-style confirm-button confirm-button-large',
        get text() { return t('confirm_appointment_btn'); },
        get loadingText() { return t('processing'); },
        type: 'button'
    },
    cancel: {
        id: 'cancel-appointment-link',
        className: 'cancel-link',
        get text() { return t('cancel_appointment'); },
        get loadingText() { return t('processing'); },
        type: 'link'
    }
};

export const APPOINTMENT_STATUS = {
    REQUEST: 'request',
    CONFIRMED: 'confirmed',
    COMPLETE: 'complete',
    CANCELLED: 'cancelled'
};

export const PARTICIPANT_TYPES = {
    LEAD: 'App\\Models\\Lead',
    STAFF: 'App\\Models\\Staff'
};

export const HTTP_STATUS = {
    OK: 200,
    CREATED: 201,
    BAD_REQUEST: 400,
    UNAUTHORIZED: 401,
    NOT_FOUND: 404,
    SERVER_ERROR: 500
};

export const COLORS = {
    error: '#e74c3c',
    success: '#11b654'
};

export const TIMEOUTS = {
    defaultToast: 3000,
    buttonReset: 2000
};
